import { ref } from 'vue'
import { defineStore } from 'pinia'
import dashboardApi from '@/api/dashboard.js'

export const useDashboardStore = defineStore('dashboard', () => {

  const dashboardData = ref({})

  const postOverviewInfo = async data => {
    return dashboardApi.overviewInfo(data).then(res => {
      dashboardData.value = res.data
      return dashboardData.value
    })
  }

  return { dashboardData, postOverviewInfo }
})
